export const faqFunc = (Accordion) => {
    const accordeon = document.querySelectorAll('.faq__container');

    if(accordeon) {
      const accOptions = {
        duration: 300,
      }

      accordeon.forEach(el => {
        new Accordion(el, accOptions);
      })
    }
}